import TOOLS from '@helpers/tools'
import FILTERS from '@helpers/filters'

import { isEmpty } from 'lodash'

export default function homeDataLayerHeader(stateId, locations, imoveis, path) {
  if (typeof window !== 'undefined') {
    let imoveisEstado = ''
    if (isEmpty(imoveis[0].Localizacao)) {
      imoveisEstado = imoveis[0].Endereco.Estado
    } else {
      imoveisEstado = imoveis[0].Localizacao.Estado
    }
    let imoveisCidade = ''
    if (isEmpty(imoveis[0].Localizacao)) {
      imoveisCidade = imoveis[0].Endereco.Cidade
    } else {
      imoveisCidade = imoveis[0].Localizacao.Cidade
    }
    window.dataLayer.push({ imoveis: undefined })
    window.dataLayer.push({
      event: 'dados-imoveis',
      showLocation: 'carrossel-header',
      pagepath: path,
      pageType: 'home',
      estado: TOOLS.slugify(imoveisEstado),
      cidade: TOOLS.slugify(imoveisCidade),
      imoveis: imoveis.map((h, index) => {
        let imovelBairro = ''
        if (isEmpty(imoveis[0].Localizacao)) {
          imovelBairro = imoveis[0].Endereco.Bairro
        } else {
          imovelBairro = imoveis[0].Localizacao.Bairro
        }
        let imovelCidade = ''
        if (isEmpty(imoveis[0].Localizacao)) {
          imovelCidade = imoveis[0].Endereco.Cidade
        } else {
          imovelCidade = imoveis[0].Localizacao.Cidade
        }
        let imovelEstado = ''
        if (isEmpty(imoveis[0].Localizacao)) {
          imovelEstado = imoveis[0].Endereco.Estado
        } else {
          imovelEstado = imoveis[0].Localizacao.Estado
        }

        return {
          id: h.ImovelId,
          nome: TOOLS.slugify(h.NomeImovel),
          bairro: TOOLS.slugify(imovelBairro),
          cidade: TOOLS.slugify(imovelCidade),
          estado: TOOLS.slugify(imovelEstado),
          areaprivativa: h.AreaPrivativaImovel ? TOOLS.slugify(h.AreaPrivativaImovel) : undefined,
          dormitorios: TOOLS.slugify(h.QuartosImovel),
          vagas: h.VagasGaragemImovel,
          valor: h.PrecoMinimo ? FILTERS.moneyBi(h.PrecoMinimo) : undefined,
          status: h.Status ? TOOLS.slugify(h.Status) : undefined,
          position: h.Ordem,
        }
      }),
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/BI/homeDataLayerHeader.js